import _ from 'lodash'

const mixinFilter = {
  data() {
    return {
      // filterColumn: [],
      // filterList: [],
    }
  },
  computed: {

  },
  methods: {
    filtersArr(column) {
      if (!this.tableColumn.length) {
        return []
      }

      const {
        type,
        prop
      } = column
      let filterArr = []
      switch (type) {
        case 'select':
        case 'checkbox':
        case 'radio':
          filterArr = this.getArrayVals(column)
          break
        default:
          filterArr = this.getStringVals(prop)
      }
      // console.log(column, this.tableColumn)
      // return [{ text: '1111', value: '1111' }]
      return filterArr
    },
    handleFilter(value, row, column) {
      const property = column['property']
      const rowVal = row[property]
      if (_.isArray(rowVal)) {
        return _.includes(rowVal, value)
      } else {
        return rowVal === value
      }
    },
    getArrayVals(column) {
      const {
        dicData,
        prop,
        type
      } = column
      const arr = []
      if (dicData?.length) {
        dicData.map(row => {
          const {
            label,
            value
          } = row
          arr.push({ text: label, value: value })
        })
      }
      return arr
    },
    getStringVals(prop) {
      const arr = []
      const finds = []
      this.tableColumn.map(row => {
        const val = row[prop]
        if (val && !(_.includes(finds, val))) {
          finds.push(val)
          arr.push({ text: val, value: val })
        }
      })
      return arr
    }
  }
}

export default mixinFilter
